import { useMutation } from '@tanstack/react-query'

import { checkAlreadyRegisteredPhoneNumber } from '@src/api'
import { DefaultApiCheckAlreadyRegisteredPhoneNumberRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks'

export const useCheckAlreadyRegisteredPhoneNumber = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiCheckAlreadyRegisteredPhoneNumberRequest) =>
      checkAlreadyRegisteredPhoneNumber(axiosInstance, params),
  })
}
